var _mask, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "group_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 94.969,
    height: 70,
    rx: 1.795
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 94.969,
    height: 70,
    rx: 1.795,
    fill: "url(#group_svg__a)",
    stroke: "#fff",
    strokeOpacity: 0.408,
    strokeWidth: 8.974,
    mask: "url(#group_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.03 21.538h29.677M25.03 32.846h44.786M25.03 46.846h15.648",
    stroke: "#7142EB",
    strokeWidth: 2.692,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.599,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.966 55.642a3.946 3.946 0 0 1 0 5.592v.001a3.969 3.969 0 0 1-5.603 0l-7.66-7.643 5.604-5.593 7.66 7.643Z",
    fill: "#E9E0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.599,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m86.307 48-5.604 5.592-6.117-6.105-.236-.036a18.197 18.197 0 0 0 5.686-5.607l.154.05L86.307 48Z",
    fill: "#E9E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M64.763 14c10.013 0 18.13 8.1 18.13 18.092 0 9.992-8.117 18.092-18.13 18.092-10.013 0-18.13-8.1-18.13-18.092C46.633 22.1 54.75 14 64.763 14Z",
    fill: "url(#group_svg__c)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.108,
    y: 75.385,
    width: 60.435,
    height: 8.615,
    rx: 1.795,
    fill: "url(#group_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.494 61.64 25.77 76.37.045 61.64 25.77 47l25.724 14.64Z",
    fill: "#E1D6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 76.37 9.803 67.228.045 72.78 25.77 87.51l25.724-14.73-9.758-5.552L25.77 76.37Z",
    fill: "#916AF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 87.51 9.803 78.366.045 83.92 25.77 98.65l25.724-14.73-9.758-5.553L25.77 87.51Z",
    fill: "#7647F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "group_svg__a",
    x1: -39.511,
    y1: 29.008,
    x2: 12.167,
    y2: 118.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8962F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "group_svg__c",
    x1: 48.111,
    y1: 14,
    x2: 48.111,
    y2: 47.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "group_svg__d",
    x1: 28.572,
    y1: 83.298,
    x2: 84.079,
    y2: 83.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBBFB"
  })))));
};
export { SvgGroup as ReactComponent };
export default "data:image/svg+xml;base64,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";